/**
 * Question → rule label: the first half of an eligibility rule's line.
 *
 * The route comes from the projection (`ruleLane` / `ruleExitX`) and the geometry from
 * `ruleWirePath`, so this component only picks the colour. It carries no label — the rule
 * label at its end IS the label.
 */
import { BaseEdge, type EdgeProps } from '@xyflow/react';

import { ruleWirePath } from '../../utils/edgePaths';
import type { LineStyle } from '../../utils/lineStyle';
import type { CpaEdge } from '../../utils/projection';

export default function RuleWireEdge({ id, sourceX, sourceY, targetX, targetY, style, data }: EdgeProps) {
  const d = data as { edge?: CpaEdge; lineStyle?: LineStyle } | undefined;
  const e = d?.edge;
  const path = ruleWirePath(
    { x: sourceX, y: sourceY },
    { x: targetX, y: targetY },
    e?.ruleLane,
    e?.ruleExitX ?? targetX - 48,
    d?.lineStyle ?? 'default',
  );
  return <BaseEdge id={id} path={path} style={style} />;
}
